import { useMemo } from "react";

export const useMerchantFilters = ({
  merchants,
  searchName,
  searchID,
  searchStatus,
  page,
  pageSize,
}) => {
  // -----------------------------
  // FILTERING
  // -----------------------------
  const filteredMerchants = useMemo(() => {
    let result = Array.isArray(merchants) ? merchants : [];

    if (searchName.trim() !== "") {
      result = result.filter((m) =>
        String(m.merchant.name || "")
          .toLowerCase()
          .includes(searchName.toLowerCase())
      );
    }

    if (searchID.trim() !== "") {
      result = result.filter((m) => String(m.merchant.id || "").includes(searchID));
    }

    if (searchStatus !== "") {
      result = result.filter((m) => String(m.merchant.approved) === searchStatus);
    }

    return result;
  }, [merchants, searchName, searchID, searchStatus]);

  // -----------------------------
  // PAGINATION (same pattern as transactions)
  // -----------------------------
  const totalPages = Math.ceil(filteredMerchants.length / pageSize) || 1;

  const paginatedMerchants = useMemo(() => {
    return filteredMerchants.slice((page - 1) * pageSize, page * pageSize);
  }, [filteredMerchants, page, pageSize]);

  return {
    filteredMerchants,
    paginatedMerchants,
    totalPages,
  };
};
